var $146218e7e6749652$exports = {};
$146218e7e6749652$exports = {
  "collapse": "Pienenn\xE4",
  "expand": "Laajenna"
};
export { $146218e7e6749652$exports as default };